import { NGRX_BUCKETS } from '@curbnturf/entities';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ReviewState } from './reviews.reducer';

// Lookup the 'Reviews' feature state managed by NgRx
export const getAllReviews = createFeatureSelector<ReviewState>(NGRX_BUCKETS.reviews);

export const getListingReviews = createSelector(getAllReviews, (state: ReviewState) => state.listingReviews);
export const getGuestReviews = createSelector(getAllReviews, (state: ReviewState) => state.guestReviews);
export const getCurrentGuestReview = createSelector(getAllReviews, (state: ReviewState) => state.currentGuestReview);
export const getBoondockReviews = createSelector(getAllReviews, (state: ReviewState) => state.boondockReviews);
export const getPoiReviews = createSelector(getAllReviews, (state: ReviewState) => state.poiReviews);
